import BlockArea from './BlockArea';
export { BlockAreaContainer } from './BlockAreaContainer';

export default BlockArea;
